import App from "@/App.tsx";
import "@/index.css";
import { store } from "@/redux/store.tsx";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";

import { Amplify } from "aws-amplify";
import { BrowserRouter } from "react-router-dom";

import { Toaster } from "@/components/ui/sonner";
import { amplifyConfig } from "@/constants/amplify_outputs";
import { Authenticator } from "@aws-amplify/ui-react";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import "./sentry";

Amplify.configure(amplifyConfig);
const persistor = persistStore(store);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Authenticator.Provider>
      <BrowserRouter>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <Toaster
              theme="light"
              toastOptions={{ classNames: { description: "text-gray-500" } }}
            />
            <App />
          </PersistGate>
        </Provider>
      </BrowserRouter>
    </Authenticator.Provider>
  </StrictMode>
);
